import React from 'react'
// @src imports
import { BottomNav, dashboardItems } from 'src/chrome/BottomNav/BottomNav'
import Awards from 'src/awards/containers/Awards'
import CardHistoryManager from 'src/card_history/containers/CardHistoryManager'
import DraftedCards from 'src/drafts/containers/DraftedCards'
import { AccountRoute } from 'src/dashboard/routes/AccountRoute'
import { AwardsRoute } from 'src/dashboard/routes/AwardsRoute'
import {
  DashboardRoute,
  DashboardSubroute,
} from 'src/dashboard/routes/DashboardRoute'
import { DraftedOrdersRoute } from 'src/dashboard/routes/DraftedOrdersRoute'
import { DraftedCardsRoute } from 'src/dashboard/routes/DraftedCardsRoute'
import { InvitesRoute } from 'src/dashboard/routes/InvitesRoute'
import { NotificationsRoute } from 'src/dashboard/routes/NotificationsRoute'
import { PaymentSettingsRoute } from 'src/dashboard/routes/PaymentSettingsRoute'
import { CardHistoryRoute } from 'src/dashboard/routes/CardHistoryRoute'
import { DashboardHeader, DashboardNav } from 'src/dashboard/components'
import { DefaultError, SuspenseBoundary } from 'src/chrome'
// relative imports
import Account from '../Account'
import DraftedOrders from '../DraftedOrders'
import Invites from '../Invites/Invites'
import Notifications from '../Notifications/Notifications'
import PaymentSettings from '../PaymentSettings/PaymentSettings'
import AnnouncementBanners from '../../../marketing/AnnouncementBanners/AnnouncementBanners'
import styles from './styles'

type DashboardProps = {
  route: DashboardRoute
}

const Dashboard: React.FC<DashboardProps> = props => {
  const { route } = props

  const routePath = route.subroute.path

  const showSidebar = !DashboardSubroute.hideSidebar(route.subroute)

  return (
    <div>
      {showSidebar && (
        <div css={styles.dashboardNavContainer}>
          <DashboardNav />
        </div>
      )}
      <div css={styles.bottomNavWrapper}>
        <div css={styles.bottomNav}>
          <BottomNav items={dashboardItems} rootCSS={styles.rootNavWrapper} />
        </div>
      </div>
      <div css={styles.dashboardWrapper}>
        <DashboardHeader routePath={routePath} />
        <div css={styles.dashboardContainer(routePath === '/account')}>
          <AnnouncementBanners />
          {routePath === AccountRoute.path && (
            <SuspenseBoundary
              unresolved={''}
              failure={() => {
                const accountError = new Error(
                  'There was an error loading your account. Please reload and try again',
                )
                return DefaultError(accountError)
              }}
            >
              <Account />
            </SuspenseBoundary>
          )}
          {routePath === AwardsRoute.path && <Awards />}
          {routePath === DraftedOrdersRoute.path && <DraftedOrders />}
          {routePath === DraftedCardsRoute.path && (
            <DraftedCards isWrapContentEnabled={true} />
          )}
          {routePath === InvitesRoute.path && <Invites />}
          {routePath === NotificationsRoute.path && <Notifications />}
          {route.subroute.path === CardHistoryRoute.path && (
            <CardHistoryManager
              route={route.subroute}
              initialSection={(route.subroute as CardHistoryRoute).section}
              initialFilters={(route.subroute as CardHistoryRoute).filters}
            />
          )}
          {routePath === PaymentSettingsRoute.path && <PaymentSettings />}
        </div>
      </div>
    </div>
  )
}

export default Dashboard
